<template>
    <van-popup
            class="district-popup"
            :value="visible"
            position="bottom"
            @close="onClose"
            @click-overlay="onClose"
            @opened="onOpened">
        <div class="district-picker">
            <div class="popup-header">
                <div class="popup-header-title">
                    区县选择
                </div>
                <van-icon class="popup-header-icon" name="cross" size="0.45rem" @click="onClose"></van-icon>
            </div>
                <cus-field background="#f0f0f0" type="search" placeholder="请输入要查询的区县" v-model="searchKey" input-background="#ededed" style="border-bottom: 0"></cus-field>
            <ul class="district-box">
                <template v-for="item in districtList">
                    <li
                            class="district-box--item"
                            @click="handleSelectItem(item)"
                            :class="{'district-box--item__active': value.districtId == item.districtId}"
                            :key="item.districtId">
                        {{item.districtName}}
                    </li>
                </template>
            </ul>
        </div>
    </van-popup>
</template>

<script>
    import {city} from "../../../utils/city.js";

    export default {
        name: "districtPicker",
        data() {
            return {
                searchKey: ''
            }
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            districtList() {
                let _code = this.value.cityId.toString().slice(0, 4)
                let list = Object.keys(city.county_list).map(code => {
                    return {
                        districtId: code,
                        districtName: city.county_list[code]
                    }
                })
                return list.filter(val => val.districtId.slice(0, 4) === _code && val.districtName.indexOf(this.searchKey) !== -1) || []
            }
        },
        methods: {
            onClose() {
                this.searchKey = ''
                this.$emit('update:visible', false)
            },
            onOpened() {
            },
            handleSelectItem(item) {
                this.$emit('input', Object.assign({}, this.value, item))
                this.$emit('update:visible', false)
                this.$emit('on-select')
            }
        }
    }
</script>

<style lang="scss">
    .district-picker {
        height: 15rem;
        display: flex;
        flex-direction: column;
        background-color: #fff;
    }

    .search-box {
        padding: 0.21rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .district-box {
        flex: 1;
        background-color: #fff;
        overflow-y: scroll;

        &--item {
            height: 1.17rem;
            line-height: 1.17rem;
            text-align: center;
            font-size: 0.39rem;
            border-top: 1px solid #e5e5e5;

            &__active {
                background-color: #FE9329;
                color: #ffffff;
                border: 1px solid #FE9329 !important;
            }
        }
    }

    .district-popup {
        background-color: transparent;
        padding: 0 0.27rem;
        box-sizing: border-box;
    }
</style>
